'use client';

import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export interface PredefinedSearchContextState {
  offerId: string;
  predefinedSearchParameters?: Content.Components['IPredefinedSearchHeadlessParameters'];
  setOfferId: Dispatch<SetStateAction<string>>;
  setPredefinedSearchParameters: Dispatch<
    SetStateAction<
      Content.Components['IPredefinedSearchHeadlessParameters'] | undefined
    >
  >;
  setTransportAllotmentId: Dispatch<string>;
  transportAllotmentId: string;
}

interface PredefinedSearchContextProviderProps {
  children: ReactNode;
  initialData?: PredefinedSearchContextState;
}

const PredefinedSearchContext = createContext<
  PredefinedSearchContextState | undefined
>(undefined);

export const PredefinedSearchContextProvider = ({
  children,
  initialData,
}: PredefinedSearchContextProviderProps) => {
  const [offerId, setOfferId] = useState<string>(initialData?.offerId ?? '');
  const [predefinedSearchParameters, setPredefinedSearchParameters] = useState<
    Content.Components['IPredefinedSearchHeadlessParameters'] | undefined
  >(initialData?.predefinedSearchParameters);
  const [transportAllotmentId, setTransportAllotmentId] = useState<string>(
    initialData?.transportAllotmentId ?? '',
  );

  return (
    <PredefinedSearchContext.Provider
      value={{
        offerId,
        predefinedSearchParameters,
        setOfferId,
        setPredefinedSearchParameters,
        setTransportAllotmentId,
        transportAllotmentId,
      }}
    >
      {children}
    </PredefinedSearchContext.Provider>
  );
};

export const usePredefinedSearchContext = () => {
  const context = useContext(PredefinedSearchContext);

  if (!context) {
    throw new Error(
      'usePredefinedSearchContext must be used within a PredefinedSearchContextProvider',
    );
  }

  return context;
};
